export const sortOptions = [
  {
    name: 'Enrolled (New to Old)',
    value: '-createdAt',
  },
  {
    name: 'Enrolled (Old to New)',
    value: 'createdAt',
  },
  {
    name: 'Started (New to Old)',
    value: '-startedAt',
  },
  {
    name: 'Started (Old to New)',
    value: 'startedAt',
  },
  {
    name: 'Last Activity (New to Old)',
    value: '-lastActivityAt',
  },
  {
    name: 'Last Activity (Old to New)',
    value: 'lastActivityAt',
  },
  {
    name: 'Completed (New to Old)',
    value: '-completedAt',
  },
  {
    name: 'Completed (Old to New)',
    value: 'completedAt',
  },
  {
    name: 'Progress (High to Low)',
    value: '-progress',
  },
  {
    name: 'Progress (Low to High)',
    value: 'progress',
  },
];

export const statusOptions = [
  {
    name: 'Enrolled',
    value: 'enrolled',
  },
  {
    name: 'Started',
    value: 'started',
  },
  {
    name: 'Pending Review',
    value: 'pending-review',
  },
  {
    name: 'Incomplete',
    value: 'incomplete',
  },
  {
    name: 'Passed',
    value: 'passed',
  },
  {
    name: 'Removed',
    value: 'removed',
  },
];

export const pageLimitOptions = [
  {
    name: '25',
    value: 25,
  },
  {
    name: '50',
    value: 50,
  },
  {
    name: '100',
    value: 100,
  },
  {
    name: '200',
    value: 200,
  },
];
